import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import {WkfSupervisionFilterState} from './reducer/wkf-supervision-filter.reducer';

export const selectWkfSupervisionFilterFeature = createFeatureSelector<WkfSupervisionFilterState>(StoreKeys.WKF_SUPERVISION_FILTERS);

export const selectWkfSupervisionFilterDatas = createSelector(selectWkfSupervisionFilterFeature, state => state.datas);

export const selectWkfSupervisionFilterDatasFilterItems = createSelector(selectWkfSupervisionFilterFeature, state => state.datas.filterItems);
export const selectWkfSupervisionFilterDatasLastAgg = createSelector(selectWkfSupervisionFilterFeature, state => state.datas.lastAgg);
